import { render, staticRenderFns } from "./new_line_discussion_form.vue?vue&type=template&id=28d5c0de&vue3"
import script from "./new_line_discussion_form.vue?vue&type=script&lang=js&vue3"
export * from "./new_line_discussion_form.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports